import { render, staticRenderFns } from "./CGradientColor.vue?vue&type=template&id=53f0cb4d&scoped=true"
import script from "./CGradientColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CGradientColor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CGradientColor.vue?vue&type=style&index=0&id=53f0cb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0cb4d",
  null
  
)

export default component.exports